import { Link } from 'react-router-dom';

export default function DownloadSection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20creative%20background%20with%20warm%20orange%20gradient%20flowing%20shapes%2C%20modern%20minimalist%20design%2C%20digital%20platform%20theme%2C%20soft%20curves%20and%20waves%2C%20teal%20accents%2C%20clean%20and%20energetic%20atmosphere%2C%20professional%20tech%20feel&width=1920&height=800&seq=download-bg-section&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-800/85 to-primary-900/85"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          随时随地，记录精彩瞬间
        </h2>
        <p className="text-background-200/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
          下载黄瓜视频APP，开启你的创作之旅。无论是拍摄、剪辑还是分享，一部手机轻松搞定。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-background-50 text-primary-700 font-semibold text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-apple-line text-xl"></i>
            <div className="text-left">
              <div className="text-[10px] leading-none">Download on the</div>
              <div className="text-base leading-none font-bold">App Store</div>
            </div>
          </Link>
          <Link
            to="/about"
            className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-google-play-line text-xl"></i>
            <div className="text-left">
              <div className="text-[10px] leading-none">GET IT ON</div>
              <div className="text-base leading-none font-bold">Google Play</div>
            </div>
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl font-bold text-background-50">4.9</div>
            <div className="flex items-center gap-0.5 mt-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
              ))}
            </div>
            <div className="text-xs text-background-300 mt-1">App Store 评分</div>
          </div>
          <div className="w-px h-12 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-background-50">1亿+</div>
            <div className="text-xs text-background-300 mt-1">累计下载量</div>
          </div>
        </div>
      </div>
    </section>
  );
}